module.exports = __webpack_public_path__ + "Android-Line.svg?46c6b373710ef94844f451b3ed3467a9";